// src/components/SalidaEntradaPatrones/MovimientoCard.jsx
import React from 'react';
import { Card, Badge, Button, ProgressBar } from 'react-bootstrap';
import { FaClock, FaCheckCircle, FaUser, FaFileAlt, FaBox } from 'react-icons/fa';
import moment from 'moment';
import 'moment/locale/es';
import StatusBadge from './StatusBadge';

moment.locale('es');

/**
 * Componente tarjeta para mostrar información de un movimiento/patrón
 */
const MovimientoCard = ({
  movimiento,
  patron,
  onViewDetails,
  onAgregarOt,
  onCompletarOt,
  onCerrarMovimiento,
  showActions = true
}) => {
  // Calcular tiempo transcurrido
  const getTiempoFuera = () => {
    if (!movimiento?.startedAt) return 'N/A';
    const now = moment();
    const start = moment(movimiento.startedAt);
    const duration = moment.duration(now.diff(start));

    console.log('movimiento:', movimiento);
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();

    if (days > 0) {
      return `${days}d ${hours}h`;
    } else if (hours > 0) {
      return `${hours}h ${minutes}m`;
    } else {
      return `${minutes}m`;
    }
  };

  // Calcular progreso de OTs
  const getProgresoOts = () => {
    if (!movimiento?.otAssignments || movimiento.otAssignments.length === 0) {
      return { completed: 0, total: 0, percentage: 0 };
    }

    const total = movimiento.otAssignments.length;
    const completed = movimiento.otAssignments.filter(ot => ot.status === 'completed').length;
    const percentage = (completed / total) * 100;

    return { completed, total, percentage };
  };

  const progreso = getProgresoOts();
  const patronInfo = movimiento?.patronId || patron;

  return (
    <Card className=" d-flex flex-column w-100">
      <Card.Header className="bg-light d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center gap-2">
          <FaBox className="text-primary" />
          <strong>{patronInfo?.inventario || 'N/A'}</strong>
        </div>
        <StatusBadge
          type="movimiento"
          status={movimiento?.status || 'open'}
          size="sm"
        />
      </Card.Header>

      <Card.Body className="flex-grow-1 d-flex flex-column w-100"
      //style={{ minHeight: '300px' }}
      >
        {/* Información del patrón */}
        <div className="mb-3">
          <h6 className="text-truncate">{patronInfo?.item || 'Sin descripción'}</h6>
          <small className="text-muted">
            {patronInfo?.marca} {patronInfo?.modelo}
            {patronInfo?.serie && ` | S/N: ${patronInfo.serie}`}
          </small>
        </div>

        {/* Magnitud */}
        {patronInfo?.magnitud && (
          <div className="mb-2">
            <Badge bg="secondary" className="w-100">
              {patronInfo.magnitud}
            </Badge>
          </div>
        )}

        {/* Tiempo fuera */}
        {movimiento?.status === 'open' && (
          <div className="d-flex align-items-center gap-2 mb-2 text-muted">
            <FaClock />
            <small>Hace {getTiempoFuera()}</small>
          </div>
        )}

        {/* Responsable */}
        {movimiento?.responsibleUserId && (
          <div className="d-flex align-items-center gap-2 mb-2 text-muted">
            <FaUser />
            <small>
              {movimiento.responsibleUserId?.nombre} {movimiento.responsibleUserId?.apellido}
            </small>
          </div>
        )}

        {/* OTs asignadas */}
        {movimiento?.otAssignments && movimiento?.otAssignments.length > 0 && (
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <small className="fw-bold">OTs:</small>
              <small className="text-muted">
                {progreso.completed}/{progreso.total}
              </small>
            </div>

            <ProgressBar
              now={progreso.percentage}
              variant={progreso.percentage === 100 ? 'success' : 'primary'}
              className="mb-2"
              style={{ height: '8px' }}
            />

            <div className="d-flex flex-column gap-1">
              {movimiento.otAssignments.slice(0, 3).map((otAssignment, idx) => (
                <div
                  key={idx}
                  className="d-flex justify-content-between align-items-center"
                >
                  <small className="text-truncate" style={{ maxWidth: '70%' }}>
                    {otAssignment.ot?.numeroOt || 'N/A'} - {otAssignment.ot ? <div className="cliente">{otAssignment.ot.cliente || 'Sin descripción'}</div> : 'Sin descripción'}
                  </small>
                  <StatusBadge
                    type="ot"
                    status={otAssignment.status}
                    size="sm"
                  />
                </div>
              ))}
              {movimiento.otAssignments.length > 3 && (
                <small className="text-muted text-center">
                  +{movimiento.otAssignments.length - 3} más
                </small>
              )}
            </div>
          </div>
        )}

        {/* Notas */}
        {movimiento?.notes && (
          <div className="mb-2">
            <small className="text-muted fst-italic">
              "{movimiento.notes.substring(0, 60)}
              {movimiento.notes.length > 60 ? '...' : ''}"
            </small>
          </div>
        )}
      </Card.Body>

      {/* Acciones */}
      {showActions && movimiento?.status === 'open' && (
        <Card.Footer className="mt-auto bg-white d-flex flex-column gap-2 w-100">
          {onAgregarOt && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => onAgregarOt(movimiento)}
            >
              + Agregar OT
            </Button>
          )}
          
          {onCompletarOt && progreso.completed < progreso.total && (
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => onCompletarOt(movimiento)}
            >
              <FaCheckCircle className="me-1" />
              Completar OT
            </Button>
          )}

          {onCerrarMovimiento && (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => onCerrarMovimiento(movimiento)}
            >
              Devolver Equipo
            </Button>
          )}

          {onViewDetails && (
            <Button
              variant="link"
              size="sm"
              className="text-decoration-none"
              onClick={() => onViewDetails(movimiento)}
            >
              Ver detalles
            </Button>
          )}
        </Card.Footer>
      )}

      {/* Información de cierre */}
      {movimiento?.status === 'closed' && movimiento?.closedAt && (
        <Card.Footer className="mt-auto bg-white d-flex flex-column gap-2 w-100">
          <small className="text-muted">
            Cerrado: {moment(movimiento.closedAt).format('DD/MM/YYYY HH:mm')}
          </small>
        </Card.Footer>
      )}
    </Card>
  );
};

export default MovimientoCard;
